export const DETAIL = {
  SEARCH_TRANSFER: "DETAIL.SEARCH_TRANSFER",
  SEARCH_TRANSFER_ERROR: "DETAIL.SEARCH_TRANSFER_ERROR",
  SEARCH_TRANSFER_SUCCESS: "DETAIL.SEARCH_TRANSFER_SUCCESS",
  GET_PROPOSALS: "DETAIL.GET_PROPOSALS",
  GET_PROPOSALS_SUCCESS: "DETAIL.GET_PROPOSALS_SUCCESS",
  GET_PROPOSALS_ERROR: "DETAIL.GET_PROPOSALS_ERROR",
  GET_ITEMS: "DETAIL.GET_ITEMS",
  GET_ITEMS_SUCCESS: "DETAIL.GET_ITEMS_SUCCESS",
  GET_ITEMS_ERROR: "DETAIL.GET_ITEMS_ERROR",
  MODIFY_ITEMS_SELECTION: "DETAIL.MODIFY_ITEMS_SELECTION",
  ADD_MANUAL: "DETAIL.ADD_MANUAL",
  EDIT_MANUAL: "DETAIL.EDIT_MANUAL",
  REMOVE_MANUAL: "DETAIL.REMOVE_MANUAL",
  SET_SELECTED_PROPOSAL: "DETAIL.SET_SELECTED_PROPOSAL",
  ADD_TRANSFER_TO_PROPSAL: "DETAIL.ADD_TRANSFER_TO_PROPSAL",
  REMOVE_TRANSFER_TO_PROPSAL: "DETAIL.REMOVE_TRANSFER_TO_PROPSAL"
};

export default DETAIL;
